<template lang="pug">
.bar-grafico
    BarraGrafico(type='BarChart', :data='dados', :options='options')
</template>

<script>
import { GChart as BarraGrafico } from 'vue-google-charts/legacy';

export default {
    name: 'GraficoBarra',
    props: {
        dados: {
            type: Array,
            default: () => []
        },
        color: {
            type: String,
            default: () => '#043c5a'
        }
    },
    components: {
        BarraGrafico
    },
    data() {
        return {
            options: {
                chartArea: { width: '60%', height: '80%' },
                hAxis: {
                    minValue: 0
                },
                legend: { position: 'bottom', maxLines: 3 },
                animation: {
                    duration: 1000,
                    easing: 'out',
                    startup: true
                },
                colors: [this.color],
                width: 550,
                height: 460
            }
        };
    }
};
</script>
